<shared-search-bar
    class="category-filter"
    [fieldDefs]="searchBarFieldDefs$ | async"
    (filterChange)="onSearchFilterChange($event)">
</shared-search-bar>
<div></div>
<button mat-flat-button class="primary-button" (click)="onAddEvent()">
    {{ 'workshop.addWorkshop' | translate }}
</button>
